import React from "react";
import "./CartModal.css";

function CartModal({ isOpen, onClose, onGoToCart, courseImage, subtotal, type = "success" }) {
  if (!isOpen) return null;

  // Configuramos los textos de manera modular según el caso de uso
  const isAlreadyInCart = type === "already_exists";
  const titleText = isAlreadyInCart ? "YA ESTÁ EN TU CARRITO" : `SUBTOTAL: S/${subtotal}`;
  const buttonText = isAlreadyInCart ? "Ver mi carrito" : "Ir al carrito";

  return (
    <div className="cart-modal-overlay" onClick={onClose}>
      <div className="cart-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Botón de cerrar (X) */}
        <button className="cart-modal-close" onClick={onClose}>
          ✕
        </button>

        {/* Cuerpo de la Modal */}
        <div className="cart-modal-body">
          <div 
            className="cart-modal-image" 
            style={{ backgroundImage: `url(${courseImage})` }}
          />
          <div className="cart-modal-info">
            <h2>{titleText}</h2>
          </div>
        </div>

        {/* Botón Inferior Dinámico */}
        <button className="cart-modal-btn-action" onClick={onGoToCart}>
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default CartModal;